/**
 * Auto-generated barrel - DO NOT EDIT MANUALLY
 * Run: pnpm gen
 */

import type { Transport } from '../transport';

import { createAnalyticsService } from './analytics.service';
import { createAppAnalyticsEventsService } from './appAnalyticsEvents.service';
import { createAssetService } from './asset.service';
import { createAuditService } from './audit.service';
import { createAuthService } from './auth.service';
import { createCallService } from './call.service';
import { createCampaignService } from './campaign.service';
import { createCaseRecordService } from './caseRecord.service';
import { createCasesAnalyticsService } from './casesAnalytics.service';
import { createDispositionService } from './disposition.service';
import { createDrugService } from './drug.service';
import { createEligibilityService } from './eligibility.service';
import { createEmailService } from './email.service';
import { createEvaluationService } from './evaluation.service';
import { createFaxService } from './fax.service';
import { createFeedbackInsightService } from './feedbackInsight.service';
import { createFeedbackService } from './feedback.service';
import { createGenericTaskService } from './genericTask.service';
import { createIngestionService } from './ingestion.service';
import { createIntentService } from './intent.service';
import { createMailboxService } from './mailbox.service';
import { createManualActionService } from './manualAction.service';
import { createManualTaskService } from './manualTask.service';
import { createMembershipService } from './membership.service';
import { createMetadataRegistryService } from './metadataRegistry.service';
import { createNoteService } from './note.service';
import { createOrganizationRoleService } from './organizationRole.service';
import { createOrganizationService } from './organization.service';
import { createOrganizationTeamService } from './organizationTeam.service';
import { createOrganizationUserService } from './organizationUser.service';
import { createOrgKeyService } from './orgKey.service';
import { createPayorService } from './payor.service';
import { createPhoneNumberService } from './phoneNumber.service';
import { createPmsService } from './pms.service';
import { createPolicyService } from './policy.service';
import { createProgramRoleService } from './programRole.service';
import { createProgramService } from './program.service';
import { createProgramTeamService } from './programTeam.service';
import { createProgramUserService } from './programUser.service';
import { createRoleService } from './role.service';
import { createSchemaService } from './schema.service';
import { createScorecardService } from './scorecard.service';
import { createScriptService } from './script.service';
import { createServiceAccountService } from './serviceAccount.service';
import { createSummaryService } from './summary.service';
import { createTeamService } from './team.service';
import { createTemplateService } from './template.service';
import { createTextService } from './text.service';
import { createUserService } from './user.service';
import { createWebhookService } from './webhook.service';
import { createWorkflowService } from './workflow.service';

export { createAnalyticsService, type AnalyticsService } from './analytics.service';
export {
  createAppAnalyticsEventsService,
  type AppAnalyticsEventsService,
} from './appAnalyticsEvents.service';
export { createAssetService, type AssetService } from './asset.service';
export { createAuditService, type AuditService } from './audit.service';
export { createAuthService, type AuthService } from './auth.service';
export { createCallService, type CallService } from './call.service';
export { createCampaignService, type CampaignService } from './campaign.service';
export { createCaseRecordService, type CaseRecordService } from './caseRecord.service';
export { createCasesAnalyticsService, type CasesAnalyticsService } from './casesAnalytics.service';
export { createDispositionService, type DispositionService } from './disposition.service';
export { createDrugService, type DrugService } from './drug.service';
export { createEligibilityService, type EligibilityService } from './eligibility.service';
export { createEmailService, type EmailService } from './email.service';
export { createEvaluationService, type EvaluationService } from './evaluation.service';
export { createFaxService, type FaxService } from './fax.service';
export {
  createFeedbackInsightService,
  type FeedbackInsightService,
} from './feedbackInsight.service';
export { createFeedbackService, type FeedbackService } from './feedback.service';
export { createGenericTaskService, type GenericTaskService } from './genericTask.service';
export { createIngestionService, type IngestionService } from './ingestion.service';
export { createIntentService, type IntentService } from './intent.service';
export { createMailboxService, type MailboxService } from './mailbox.service';
export { createManualActionService, type ManualActionService } from './manualAction.service';
export { createManualTaskService, type ManualTaskService } from './manualTask.service';
export { createMembershipService, type MembershipService } from './membership.service';
export {
  createMetadataRegistryService,
  type MetadataRegistryService,
} from './metadataRegistry.service';
export { createNoteService, type NoteService } from './note.service';
export {
  createOrganizationRoleService,
  type OrganizationRoleService,
} from './organizationRole.service';
export { createOrganizationService, type OrganizationService } from './organization.service';
export {
  createOrganizationTeamService,
  type OrganizationTeamService,
} from './organizationTeam.service';
export {
  createOrganizationUserService,
  type OrganizationUserService,
} from './organizationUser.service';
export { createOrgKeyService, type OrgKeyService } from './orgKey.service';
export { createPayorService, type PayorService } from './payor.service';
export { createPhoneNumberService, type PhoneNumberService } from './phoneNumber.service';
export { createPmsService, type PmsService } from './pms.service';
export { createPolicyService, type PolicyService } from './policy.service';
export { createProgramRoleService, type ProgramRoleService } from './programRole.service';
export { createProgramService, type ProgramService } from './program.service';
export { createProgramTeamService, type ProgramTeamService } from './programTeam.service';
export { createProgramUserService, type ProgramUserService } from './programUser.service';
export { createRoleService, type RoleService } from './role.service';
export { createSchemaService, type SchemaService } from './schema.service';
export { createScorecardService, type ScorecardService } from './scorecard.service';
export { createScriptService, type ScriptService } from './script.service';
export { createServiceAccountService, type ServiceAccountService } from './serviceAccount.service';
export { createSummaryService, type SummaryService } from './summary.service';
export { createTeamService, type TeamService } from './team.service';
export { createTemplateService, type TemplateService } from './template.service';
export { createTextService, type TextService } from './text.service';
export { createUserService, type UserService } from './user.service';
export { createWebhookService, type WebhookService } from './webhook.service';
export { createWorkflowService, type WorkflowService } from './workflow.service';

/**
 * Build every Compass API service over a single transport.
 *
 * Call this once per transport. Long-lived clients (the dashboards) can hold the
 * result in a module constant; request-scoped clients (ui/ai-chat, which forwards
 * each user's bearer token) MUST call it per request so one user's credentials can
 * never serve another user's concurrent request.
 */
export const createServices = (transport: Transport) => ({
  analyticsService: createAnalyticsService(transport),
  appAnalyticsEventsService: createAppAnalyticsEventsService(transport),
  assetService: createAssetService(transport),
  auditService: createAuditService(transport),
  authService: createAuthService(transport),
  callService: createCallService(transport),
  campaignService: createCampaignService(transport),
  caseRecordService: createCaseRecordService(transport),
  casesAnalyticsService: createCasesAnalyticsService(transport),
  dispositionService: createDispositionService(transport),
  drugService: createDrugService(transport),
  eligibilityService: createEligibilityService(transport),
  emailService: createEmailService(transport),
  evaluationService: createEvaluationService(transport),
  faxService: createFaxService(transport),
  feedbackInsightService: createFeedbackInsightService(transport),
  feedbackService: createFeedbackService(transport),
  genericTaskService: createGenericTaskService(transport),
  ingestionService: createIngestionService(transport),
  intentService: createIntentService(transport),
  mailboxService: createMailboxService(transport),
  manualActionService: createManualActionService(transport),
  manualTaskService: createManualTaskService(transport),
  membershipService: createMembershipService(transport),
  metadataRegistryService: createMetadataRegistryService(transport),
  noteService: createNoteService(transport),
  organizationRoleService: createOrganizationRoleService(transport),
  organizationService: createOrganizationService(transport),
  organizationTeamService: createOrganizationTeamService(transport),
  organizationUserService: createOrganizationUserService(transport),
  orgKeyService: createOrgKeyService(transport),
  payorService: createPayorService(transport),
  phoneNumberService: createPhoneNumberService(transport),
  pmsService: createPmsService(transport),
  policyService: createPolicyService(transport),
  programRoleService: createProgramRoleService(transport),
  programService: createProgramService(transport),
  programTeamService: createProgramTeamService(transport),
  programUserService: createProgramUserService(transport),
  roleService: createRoleService(transport),
  schemaService: createSchemaService(transport),
  scorecardService: createScorecardService(transport),
  scriptService: createScriptService(transport),
  serviceAccountService: createServiceAccountService(transport),
  summaryService: createSummaryService(transport),
  teamService: createTeamService(transport),
  templateService: createTemplateService(transport),
  textService: createTextService(transport),
  userService: createUserService(transport),
  webhookService: createWebhookService(transport),
  workflowService: createWorkflowService(transport),
});

export type Services = ReturnType<typeof createServices>;
